import { z } from 'zod';

export interface PasswordSchemaMessages {
  minLength: string;
  uppercase: string;
  lowercase: string;
  number: string;
  mismatch: string;
}

export function createFormSchema(messages: PasswordSchemaMessages) {
  return z
    .object({
      password: z
        .string()
        .min(12, messages.minLength)
        .regex(/[A-Z]/, messages.uppercase)
        .regex(/[a-z]/, messages.lowercase)
        .regex(/\d/, messages.number),
      confirmPassword: z.string(),
      totpCode: z.string(),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: messages.mismatch,
      path: ['confirmPassword'],
    });
}

export type UpdatePasswordFormData = z.infer<ReturnType<typeof createFormSchema>>;
